module.exports = [{
      plugin: require('/www/haafPortfolio/gatsby-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
